import React from 'react'
import {
  TransactionModalState,
  TransactionsDetailsItemFromServer,
} from './types'
import { path } from '../../../../../libs'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import { CButton } from '@coreui/react-pro'
import { Guard } from '../../../../../features/session/guard'
import { GUARD_RULES } from '../../../../../features/session/constants'
import { Link } from 'react-router-dom'

export const mapScopedColumns = (
  openModal: (
    modalName: keyof Omit<TransactionModalState, 'transactionId' | 'wallet'>,
    transaction: TransactionsDetailsItemFromServer,
  ) => void,
) => ({
  clientId: (item: TransactionsDetailsItemFromServer) => {
    const clientId = item.clientId

    return (
      <td>
        {clientId ? (
          <Link
            to={path.clients.details(String(clientId))}
            target="_blank"
            style={{ fontSize: 14, fontWeight: 600 }}
          >
            {clientId}
          </Link>
        ) : (
          <span>-</span>
        )}
      </td>
    )
  },

  budgetItem: (item: TransactionsDetailsItemFromServer) => {
    const budgetItem = item.budgetItem
    const type = item.type

    return (
      <td>
        {budgetItem && type === 'Budget payment' ? (
          <span>{budgetItem}</span>
        ) : (
          <span>-</span>
        )}
      </td>
    )
  },

  id: (item: TransactionsDetailsItemFromServer) => {
    if (item.type === 'Withdrawal') {
      return (
        <td>
          <a target="_blank" href={path.billing.withdrawal.edit(item.id)}>
            {item.id}
          </a>
        </td>
      )
    }
    if (item.type === 'Deposit') {
      return (
        <td>
          <a target="_blank" href={path.billing.deposit.edit(item.id)}>
            {item.id}
          </a>
        </td>
      )
    }
    return <td>{item.id}</td>
  },
  action: (item: TransactionsDetailsItemFromServer) => {
    if (item.type === 'Withdrawal') {
      return (
        <td>
          <Guard permission={GUARD_RULES.EDIT_FINSYSTEM_CLIENT_TRANSACTION}>
            <CButton
              color="secondary"
              className="me-2"
              title={'Edit'}
              onClick={() => openModal('editWalletTransactionModal', item)}
            >
              <CIcon icon={cilPencil} />
            </CButton>
          </Guard>
        </td>
      )
    }

    if (item.type === 'Deposit') {
      return (
        <td>
          <Guard permission={GUARD_RULES.EDIT_FINSYSTEM_CLIENT_TRANSACTION}>
            <CButton
              color="secondary"
              className="me-2"
              title={'Edit'}
              onClick={() => openModal('editWalletTransactionModal', item)}
            >
              <CIcon icon={cilPencil} />
            </CButton>
          </Guard>
        </td>
      )
    }

    if (item.type === 'Rollback') {
      return (
        <td>
          <Guard permission={GUARD_RULES.EDIT_FINSYSTEM_CLIENT_TRANSACTION}>
            <CButton
              color="secondary"
              className="me-2"
              title={'Edit'}
              onClick={() => openModal('editWalletTransactionModal', item)}
            >
              <CIcon icon={cilPencil} />
            </CButton>
          </Guard>
        </td>
      )
    }

    if (item.type === 'Other payment') {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createOtherModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (
      ['transfer', 'Outgoing int transfer', 'Incoming int transfer'].includes(
        item.type,
      )
    ) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createTransferModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (item.type === 'Budget payment') {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createBudgetPaymentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (item.type === 'dividend' || item.type === 'lp_investment') {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createDividendModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (
      item.type === 'investment' ||
      item.type === 'lp_dividend' ||
      item.type === 'earning'
    ) {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createInvestmentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }

    if (item.type === 'Commission') {
      return (
        <td>
          <CButton
            color="secondary"
            className="me-2"
            title={'Edit'}
            onClick={() => openModal('createCommissionPaymentModal', item)}
          >
            <CIcon icon={cilPencil} />
          </CButton>
        </td>
      )
    }
    return <td></td>
  },
})
